import { z } from 'zod';

const passwordSchema = z
  .string()
  .min(8, 'passwordCriteria.minLength')
  .regex(/[A-Z]/, 'passwordCriteria.uppercase')
  .regex(/[a-z]/, 'passwordCriteria.lowercase')
  .regex(/[0-9]/, 'passwordCriteria.number')
  .regex(/[^A-Za-z0-9]/, 'passwordCriteria.special');

const withConfirmPassword = <
  T extends Record<string, z.ZodType> & { newPassword: z.ZodType<string> },
>(
  schema: z.ZodObject<T>
) =>
  schema
    .extend({
      confirmPassword: z.string(),
    })
    .refine(
      (data) => {
        const d = data as { newPassword: string; confirmPassword: string };
        return d.newPassword === d.confirmPassword;
      },
      {
        message: 'validation.passwordsDoNotMatch',
        path: ['confirmPassword'],
      }
    );

export const changePasswordOneTimeSchema = withConfirmPassword(
  z.object({
    newPassword: passwordSchema,
  })
);

export const changePasswordSchema = withConfirmPassword(
  z.object({
    currentPassword: z.string().min(1, 'validation.currentPasswordRequired'),
    newPassword: passwordSchema,
  })
);

export const resetPasswordSchema = withConfirmPassword(
  z.object({
    code: z.string().min(1, 'validation.verificationCodeRequired'),
    newPassword: passwordSchema,
  })
);

export const emailSchema = z.object({
  email: z.string().email('validation.invalidEmail'),
});
